const NS = 'MarketReportsListingItemWidget';
const CLS = 'marketReportsListingItemWidget';

import { handleTruncate } from '../../../../global/js/truncate';

export class MarketReportsListingItemWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.limit = 210; // reserved limit (characters)
		this.$summary = this.$element.find(`.${CLS}-desc`);
		this.summaryHtml = this.$summary.html();
		this.summaryText = this.$summary.text(); // for comparison without the extra characters from html tags
		this.originalHtml = this.summaryHtml;

		// handle truncate (read more / read less)
		// (true) disabled read more / read less function
		handleTruncate(this, true);

		// read more should link to the item
		this.$element.on('click', '.read-more', () => {
			console.log(this.$element.find(`.${CLS}-title a`));
			this.$element.find(`.${CLS}-title a`)[0].click();
		});
	}
}
